import React, { useEffect, useMemo, useState } from 'react';
import { apiClient } from '../services/api';
import LoadingSpinner from '../components/LoadingSpinner';

function SupportTokenHandoffPage() {
  const [error, setError] = useState<string | null>(null);

  const params = useMemo(() => new URLSearchParams(window.location.search), []);
  const rawNext = params.get('next') || '/admin';
  const nextPath = rawNext.startsWith('/') ? rawNext : '/admin';
  const token = params.get('token') || '';

  useEffect(() => {
    if (!token) {
      setError('Missing support handoff token. Please sign in again from the platform host.');
      return;
    }

    localStorage.setItem('token', token);
    apiClient.defaults.headers.common.Authorization = `Bearer ${token}`;
    window.location.replace(nextPath);
  }, [nextPath, token]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface px-page-gutter">
        <div className="max-w-lg rounded-card bg-surface-container-lowest p-6 shadow-ambient">
          <h1 className="text-xl font-semibold text-on-surface">Unable to complete tenant handoff</h1>
          <p className="mt-2 text-sm text-on-surface-variant">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface px-page-gutter">
      <div className="flex items-center gap-3 rounded-card bg-surface-container-lowest p-5 shadow-ambient">
        <LoadingSpinner size="sm" />
        <span className="text-sm text-on-surface-variant">Signing you into the selected tenant...</span>
      </div>
    </div>
  );
}

export default SupportTokenHandoffPage;
